import { Component } from "react";
import {
  message,
  Typography,
  List,
  Checkbox,
  Tag,
  Card,
  Row,
  Col,
  Radio,
  Divider,
} from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { ModalItem, ButtonItem, Form , InputNumberItem} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import listaEmpaquetadoPdf from "../../../../Pdf/listaEmpaquetadoPdf";
import {
  BoxPlotOutlined,
  RocketOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  ShoppingCartOutlined,
  AppstoreAddOutlined,
  DownloadOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text, Title } = Typography;

class ModalGenerarGuia extends Component {
  state = {
    loading: false,
    venta: null,
    insumosFiltrados: [],
    itemsEmpaquetados: {},
    modoEmpaque: null, // 'unico' | 'partida'
    cajaUnica: null,
    cajasPorPartida: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.ventaId) {
      this.consultarVentaDetalle();
    }
    if (!this.props.visible && prevProps.visible) {
        this.setState({
            venta: null,
            insumosFiltrados: [],
            itemsEmpaquetados: null,
            modoEmpaque: null,
            cajaUnica: null,
            cajasPorPartida: null,
        });
    }
  }

  consultarVentaDetalle = () => {
    this.setState({ loading: true });
    const { ventaId, empresaId, headersToken, origenKey } = this.props;

    axios
      .post(
        "ventasEcommerce/obtenerVentaPorId",
        { ventaId, empresaId },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const venta = res.data.venta;
          const esDropshipping = origenKey === "dropshipping_urrea";
          const filtrados = venta.insumos.filter(
            (ins) => !!ins.dropshipping === esDropshipping,
          );

          const itemsEmpaquetadosObj = {};
          const cajasPartidaObj = {};
          
          let pesoTotalGlobal = 0;
          let valorTotalGlobal = 0;
          let altoGlobal = 0;
          let anchoGlobal = 0;
          let largoGlobal = 0;

          filtrados.forEach((ins) => {
            itemsEmpaquetadosObj[ins._id] = ins.empaquetado || false;
            
            const qty = ins.cantidad || 1;
            const pesoUnidad = Number(ins.pesoEnKGM) || 0.1;
            const alto = Number(ins.alto) || 10;
            const ancho = Number(ins.ancho) || 10;
            const fondo = Number(ins.fondo) || 10;
            const precioTotalItem = (ins.precioUnitarioAjustado || ins.precioUnitario || 1) * qty;

            pesoTotalGlobal += (pesoUnidad * qty);
            valorTotalGlobal += precioTotalItem;
            const dims = [alto, ancho, fondo].sort((a, b) => a - b);
            largoGlobal = Math.max(largoGlobal, dims[2]);
            anchoGlobal = Math.max(anchoGlobal, dims[1]);
            altoGlobal += (dims[0] * qty); 

            cajasPartidaObj[ins._id] = {
                cantidadCajas: 1, 
                descripcion: ins.descripcion || ins.leyenda || "Paquete",
                peso: Number((pesoUnidad * qty).toFixed(2)),
                largo: dims[2],
                ancho: dims[1],
                alto: (dims[0] * qty),
                valorDeclarado: Number(precioTotalItem.toFixed(2))
            };
          });

          this.setState({
            venta,
            insumosFiltrados: filtrados,
            itemsEmpaquetados: itemsEmpaquetadosObj,
            modoEmpaque: 'unico', 
            cajaUnica: {
                cantidadCajas: 1,
                descripcion: "Paquete Variado",
                peso: Number(pesoTotalGlobal.toFixed(2)),
                largo: largoGlobal,
                ancho: anchoGlobal,
                alto: altoGlobal,
                valorDeclarado: Number(valorTotalGlobal.toFixed(2))
            },
            cajasPorPartida: cajasPartidaObj,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
          message.warning(res.data.message);
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        message.error("Error al obtener el detalle de la venta");
      });
  };

  handleToggleEmpaquetado = (insumoId) => {
    this.setState((prevState) => ({
      itemsEmpaquetados: {
        ...prevState.itemsEmpaquetados,
        [insumoId]: !prevState.itemsEmpaquetados[insumoId],
      },
    }));
  };

  validarTodoEmpaquetado = () => {
    const { insumosFiltrados, itemsEmpaquetados } = this.state;
    if (insumosFiltrados.length === 0) return false;
    return insumosFiltrados.every((ins) => itemsEmpaquetados[ins._id]);
  };

  marcarTodoListo = () => {
    const { insumosFiltrados } = this.state;
    const todos = {};
    insumosFiltrados.forEach((ins) => {
      todos[ins._id] = true;
    });
    this.setState({ itemsEmpaquetados: todos });
  };

  descargarPdfEmpaque = async () => {
    const { ventaId, empresaId, origenKey, headersToken } = this.props;
    const { venta } = this.state;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "ventasEcommerce/datosPdfEmpaquetado",
        { ventaId, empresaId, origenKey },
        { headers: headersToken },
      );
      if (res.data.success !== 2) {
        return message.warning(
          res.data.message || "No se pudieron obtener los datos del PDF.",
        );
      }
      const dd = listaEmpaquetadoPdf(res.data);
      pdfMake
        .createPdf(dd)
        .download(`Empaquetado_${venta?.serieNumero || ventaId}.pdf`);
    } catch (err) {
      message.error("No se pudo generar el PDF de la lista.");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCajaUnicaChange = (campo, valor) => {
    this.setState(prevState => ({
        cajaUnica: {
            ...prevState.cajaUnica,
            [campo]: valor
        }
    }));
  };

  handleCajasPartidaChange = (insumoId, campo, valor) => {
    this.setState(prevState => ({
        cajasPorPartida: {
            ...prevState.cajasPorPartida,
            [insumoId]: {
                ...prevState.cajasPorPartida[insumoId],
                [campo]: valor
            }
        }
    }));
  };

  guardarProgreso = () => {
    const { ventaId, empresaId, headersToken } = this.props;
    const { itemsEmpaquetados } = this.state;

    const insumosAActualizar = Object.keys(itemsEmpaquetados).map((id) => ({
      insumoId: id,
      empaquetado: itemsEmpaquetados[id],
    }));

    this.setState({ loading: true });
    axios
      .post(
        "ventasEcommerce/guardarProgreso",
        { ventaId, empresaId, insumos: insumosAActualizar },
        { headers: headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) message.success("Progreso guardado");
      })
      .catch(() => this.setState({ loading: false }));
  };

  generarGuia = () => {
    const { ventaId, origenKey, empresaId, headersToken } = this.props;
   const { itemsEmpaquetados, modoEmpaque, cajaUnica, cajasPorPartida } = this.state;

   let cajasPersonalizadas = [];
    if (modoEmpaque === 'unico' && cajaUnica) {
        cajasPersonalizadas = [cajaUnica];
    } else if (modoEmpaque === 'partida' && cajasPorPartida) {
        cajasPersonalizadas = Object.values(cajasPorPartida);
    }

    this.setState({ loading: true });

    const insumosAActualizar = Object.keys(itemsEmpaquetados).map((id) => ({
        insumoId: id,
        empaquetado: itemsEmpaquetados[id],
      }));

    axios.post("ventasEcommerce/guardarProgreso", 
      {ventaId, empresaId, insumos: insumosAActualizar},
      { headers: headersToken }
    )
    .then((resProgreso)=> {
      if (resProgreso.data.success !== 2) {
        this.setState({ loading: false });
        return message.warning("No se pudo guardar el progreso antes de generar la guía.");
      }
      axios
        .post(
          "ventasEcommerce/generarGuiaEnvio",
          { ventaId, origenKey, empresaId, cajasPersonalizadas },
          { headers: headersToken },
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("¡Guía generada exitosamente!");
            this.props.onSuccess({ 
              labelUrl: res.data.labelUrl, 
              trackingNumber: res.data.trackingNumber 
            });
          }else if (res.data.success === 0 || res.data.success === 1){
            message.warning("¡Ocurrio un error generando la guía!");
          }
        })
        .catch((err) => {
          console.error("Error en Axios:", err);
          this.setState({ loading: false });
          message.error("Error al obtener el detalle de la venta");
        });
    })
    .catch((err) =>{
      this.setState({ loading: false });
      message.error("Error de conexión al procesar la guía.");
    })
  };

  calcularCajaSugerida = (item) => {
    if (!item) return null;
    const qty = item.cantidad || 1;
    const pesoUnidad = Number(item.pesoEnKGM) || 0.1;
    const alto = Number(item.alto) || 10;
    const ancho = Number(item.ancho) || 10;
    const fondo = Number(item.fondo) || 10;
 
    // Ordenar: [menor, media, mayor]
    const dims = [alto, ancho, fondo].sort((a, b) => a - b);
 
    const largo = dims[2];          // lado mayor — no cambia
    const anchoCaja = dims[1];      // lado medio — no cambia
    const altoApilado = Math.ceil(dims[0] * qty); // lado menor × qty
 
    return {
      pesoTotal: (pesoUnidad * qty).toFixed(2),
      dimensiones: {
        largo,
        ancho: anchoCaja,
        alto: altoApilado,
      },
      dimensionesTexto: `${largo}x${anchoCaja}x${altoApilado} CM`,
    };
  };

  render() {
    const { visible, onCancel } = this.props;
    const { venta, insumosFiltrados, itemsEmpaquetados, loading, modoEmpaque, cajaUnica, cajasPorPartida } = this.state;
    
    const todoListo = this.validarTodoEmpaquetado();
    return (
      <ModalItem
        title={
          <span>
            <BoxPlotOutlined /> Empaquetado Local
            
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        width={800}
        spinning={loading}
        
      >
        <Form
          name="form_empaquetado_guia"
          bottom={
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              
              <ButtonItem
                onClick={this.guardarProgreso}
                loading={loading}
                cyan
              >
                Guardar Progreso
              </ButtonItem>
              <ButtonItem
                type="primary"
                onClick={this.generarGuia}
                disabled={!todoListo}
                verde
                icon={<RocketOutlined />}
              >
                Generar Guía
              </ButtonItem>
            </div>
          }
        >
          {venta && (
            <>
              <Card size="small" style={{ marginBottom: 20, background: "#ffffff", borderRadius: "10px", border: "1px solid #e8e8e8" }}>
                <Row gutter={16} align="middle">
                  <Col span={14} style={{ borderRight: "1px solid #f0f0f0" }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
                      <Tag color="blue" style={{ fontSize: "14px", padding: "2px 8px" }}>Folio: {venta.serieNumero}</Tag>
                      <Title level={5} style={{ margin: 0, marginLeft: 8, color: "#333" }}>
                        <UserOutlined /> {venta.clienteOnline?.nombre} {venta.clienteOnline?.apellidoPaterno}
                      </Title>
                    </div>
                    <div style={{ color: "#8c8c8c", fontSize: "13px" }}>
                      <MailOutlined style={{ marginRight: 5 }} /> {venta.clienteOnline?.email}
                      <Divider type="vertical" />
                      <PhoneOutlined style={{ marginRight: 5 }} /> {venta.clienteOnline?.telefono}
                    </div>
                  </Col>
                  <Col span={10}>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: "#595959", marginBottom: 4 }}>
                        <ShoppingCartOutlined /> Costo Envío: <Text strong>${venta.totalEnvioCobrado?.toFixed(2)}</Text>
                      </div>
                      <div style={{ background: "#f6ffed", padding: "4px 12px", borderRadius: "6px", display: "inline-block" }}>
                        <Text type="secondary" style={{ fontSize: "12px" }}>Total de la Venta</Text>
                        <Title level={4} style={{ margin: 0, color: "#52c41a" }}>${venta.total?.toFixed(2)}</Title>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>

              <List
                header={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 8,
                    }}
                  >
                    <Text strong style={{ fontSize: "15px" }}>
                      Paso 1: Confirmar artículos (Picking)
                    </Text>
                    <div style={{ display: "flex", gap: 8 }}>
                      <ButtonItem
                        size="small"
                        blanco
                        icon={<DownloadOutlined />}
                        onClick={this.descargarPdfEmpaque}
                        disabled={insumosFiltrados.length === 0}
                      >
                        Descargar PDF
                      </ButtonItem>
                      <ButtonItem
                        size="small"
                        morado
                        icon={<CheckSquareOutlined />}
                        onClick={this.marcarTodoListo}
                        disabled={insumosFiltrados.length === 0}
                      >
                        Marcar todo como listo
                      </ButtonItem>
                    </div>
                  </div>
                }
                bordered
                dataSource={insumosFiltrados}
                style={{ background: "white", borderRadius: "8px", marginBottom: 20 }}
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Checkbox
                        checked={itemsEmpaquetados ? itemsEmpaquetados[item._id] : false}
                        onChange={() => this.handleToggleEmpaquetado(item._id)}
                      > Listo </Checkbox>,
                    ]}
                  >
                    <List.Item.Meta
                      title={<Text strong style={{ color: "#1890ff" }}>{item.descripcion}</Text>}
                      description={
                        <div style={{ fontSize: 12, marginTop: 4 }}>
                          <Text type="secondary">Dims Base: {item.alto||0}x{item.ancho||0}x{item.fondo||0}</Text>
                          <Divider type="vertical" />
                          <Text type="secondary">Peso: {item.pesoEnKGM||0} KG</Text>
                          <Divider type="vertical" />
                          <Tag color="blue" style={{ borderRadius: "10px" }}>Cant: {item.cantidad}</Tag>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />

              {todoListo && (
                  <div style={{ padding: '15px', background: '#f0f5ff', borderRadius: '8px', border: '1px solid #adc6ff' }}>
                      <div style={{ marginBottom: 15, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Text strong style={{ fontSize: "15px" }}>Paso 2: ¿Cómo vas a empaquetar esto?</Text>
                          <Radio.Group 
                              value={modoEmpaque} 
                              onChange={e => this.setState({ modoEmpaque: e.target.value })}
                              buttonStyle="solid"
                          >
                              <Radio.Button value="unico">Todo en 1 Caja</Radio.Button>
                              <Radio.Button value="partida">Por Partida (Varias cajas)</Radio.Button>
                          </Radio.Group>
                      </div>

                      {modoEmpaque === 'unico' && cajaUnica && (
                          <Row gutter={[16, 16]}>
                              <Col span={24}><Text type="secondary">Configura las dimensiones de la caja final donde meterás todo:</Text></Col>
                              <Col span={4}>
                                  <Text style={{fontSize: 12}}>Largo (cm)</Text>
                                  <InputNumberItem style={{width: '100%'}} value={cajaUnica.largo} onChange={v => this.handleCajaUnicaChange('largo', v)} />
                              </Col>
                              <Col span={4}>
                                  <Text style={{fontSize: 12}}>Ancho (cm)</Text>
                                  <InputNumberItem style={{width: '100%'}} value={cajaUnica.ancho} onChange={v => this.handleCajaUnicaChange('ancho', v)} />
                              </Col>
                              <Col span={4}>
                                  <Text style={{fontSize: 12}}>Alto (cm)</Text>
                                  <InputNumberItem style={{width: '100%'}} value={cajaUnica.alto} onChange={v => this.handleCajaUnicaChange('alto', v)} />
                              </Col>
                              <Col span={4}>
                                  <Text style={{fontSize: 12}}>Peso (kg)</Text>
                                  <InputNumberItem style={{width: '100%'}} value={cajaUnica.peso} onChange={v => this.handleCajaUnicaChange('peso', v)} />
                              </Col>
                              <Col span={4}>
                                  <Text style={{fontSize: 12}}>Valor ($)</Text>
                                  <InputNumberItem style={{width: '100%'}} value={cajaUnica.valorDeclarado} onChange={v => this.handleCajaUnicaChange('valorDeclarado', v)} />
                              </Col>
                              <Col span={4}>
                                  <Text style={{fontSize: 12}}>Cajas Idénticas</Text>
                                  <InputNumberItem style={{width: '100%'}} value={cajaUnica.cantidadCajas} onChange={v => this.handleCajaUnicaChange('cantidadCajas', v)} />
                              </Col>
                          </Row>
                      )}

                      {modoEmpaque === 'partida' && cajasPorPartida && (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                              <Text type="secondary">Configura en cuántas cajas vas a dividir cada partida (ej. si son 10 articulos, puedes poner 2 cajas de 5):</Text>
                              {insumosFiltrados.map(ins => {
                                  const c = cajasPorPartida[ins._id];
                                  if(!c) return null;
                                  return (
                                      <div key={ins._id} style={{ background: '#fff', padding: '10px', borderRadius: '6px', border: '1px solid #d9d9d9' }}>
                                          <div style={{ marginBottom: 8 }}>
                                              <AppstoreAddOutlined style={{color: '#1890ff'}}/> <Text strong>{ins.descripcion}</Text> <Text type="secondary">({ins.cantidad} piezas)</Text>
                                          </div>
                                          <Row gutter={[10, 10]}>
                                              <Col span={4}>
                                                <Text style={{fontSize: 11}}>Largo(cm)</Text>
                                                <InputNumberItem size="small" style={{width: '100%'}} value={c.largo} onChange={v => this.handleCajasPartidaChange(ins._id, 'largo', v)} />
                                              </Col>
                                              <Col span={4}>
                                                <Text style={{fontSize: 11}}>Ancho(cm)</Text>
                                                <InputNumberItem size="small" style={{width: '100%'}} value={c.ancho} onChange={v => this.handleCajasPartidaChange(ins._id, 'ancho', v)} />
                                              </Col>
                                              <Col span={4}>
                                                <Text style={{fontSize: 11}}>Alto(cm)</Text>
                                                <InputNumberItem size="small" style={{width: '100%'}} value={c.alto} onChange={v => this.handleCajasPartidaChange(ins._id, 'alto', v)} />
                                              </Col>
                                              <Col span={4}>
                                                <Text style={{fontSize: 11}}>Peso/Caja(kg)</Text>
                                                <InputNumberItem size="small" style={{width: '100%'}} value={c.peso} onChange={v => this.handleCajasPartidaChange(ins._id, 'peso', v)} />
                                              </Col>
                                              <Col span={4}>
                                                <Text style={{fontSize: 11}}>Valor/Caja($)</Text>
                                                <InputNumberItem size="small" style={{width: '100%'}} value={c.valorDeclarado} onChange={v => this.handleCajasPartidaChange(ins._id, 'valorDeclarado', v)} />
                                              </Col>
                                              <Col span={4}>
                                                <Text style={{fontSize: 11, color: '#fa8c16'}} strong>N° Cajas</Text>
                                                <InputNumberItem size="small" style={{width: '100%'}} value={c.cantidadCajas} onChange={v => this.handleCajasPartidaChange(ins._id, 'cantidadCajas', v)} />
                                              </Col>
                                          </Row>
                                      </div>
                                  );
                              })}
                          </div>
                      )}
                  </div>
              )}
            </>
          )}
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalGenerarGuia);
